const androidUrl = 'https://play.google.com/store/apps/details?id=br.com.multiplan.mind.multishopping&hl=pt_BR&gl=US';
const appleUrl = 'https://apps.apple.com/br/app/multi-lojas-shopping-online/id1459566420';

export { androidUrl, appleUrl };
